import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginConfig } from './login.config';

@Injectable({
  providedIn: 'root'
})
export class LoginConfigService {
  protected config$: BehaviorSubject<LoginConfig>;

  constructor(
    private config: LoginConfig,
  ) {
    this.config$ = new BehaviorSubject<LoginConfig>(this.config);
  }

  /**
   * Get the config as observable
   *
   * @return Observable<LoginConfig>
   */
  public getConfig(): Observable<LoginConfig> {
    return this.config$.asObservable();
  }

  /**
   * Set the config
   *
   * @param config: Partial<LoginConfig>
   * @return void
   */
  public setConfig(config: Partial<LoginConfig>): void {
    this.config$.next({
      ...this.config,
      ...config,
    });
  }
}
